export default __webpack_public_path__ + "static/media/27.b01180e4.svg";